import { Component, computed, effect, inject } from '@angular/core';
import { Auth } from '../../services/auth';

type Environment = 'dev' | 'staging' | null;

const ENV_BANNER_HEIGHT = '28px';

// Users in this list never see the environment banner, regardless of hostname.
const HIDDEN_FOR_EMAILS = ['farida.madalova@reflact.com'];

function detectEnvironment(): Environment {
  const hostname = window.location.hostname;
  if (hostname.includes('pkvdev')) {
    return 'dev';
  }
  if (hostname.includes('staging')) {
    return 'staging';
  }
  return null;
}

@Component({
  selector: 'app-environment-banner',
  imports: [],
  templateUrl: './environment-banner.html'
})
export class EnvironmentBanner {
  private authService = inject(Auth);
  private readonly detectedEnv: Environment = detectEnvironment();

  protected readonly env = computed<Environment>(() => {
    const email = this.authService.user()?.email;
    if (email && HIDDEN_FOR_EMAILS.includes(email)) {
      return null;
    }
    return this.detectedEnv;
  });

  constructor() {
    effect(() => {
      document.documentElement.style.setProperty('--env-banner-height', this.env() ? ENV_BANNER_HEIGHT : '0px');
    });
  }
}
